import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PillNav from './PillNav';
import Footer from './Footer';
import About from './About';
import Contact from './Contact';
import Services from './Services';
import HeroAndSections from './HeroAndSections';
import Iridescence from './Iridescence';
import logo from './assets/syltix.png';

function AppContent() {
  const location = useLocation();
  
  const navItems = [
    { label: 'Home', href: '/', ariaLabel: 'Home' },
    { label: 'Services', href: '/services', ariaLabel: 'Services' },
    { label: 'Contact Us', href: '/contact', ariaLabel: 'Contact Us' },
  ];

  return (
    <div 
      className="min-h-screen min-h-[100dvh] w-full bg-[#0a0a14] ios-safe-area mb-0"
      style={{ marginBottom: 0, paddingBottom: 0 }}
    >
      {/* Iridescence Background - Extended to cover safe areas */}
      <div 
        className="fixed z-0 ios-background-cover"
        style={{
          width: '100%',
          height: '900vh',
          minHeight: '900vh',
          maxHeight: 'none',
          top: 'calc(-100vh - env(safe-area-inset-top, 0px))',
          bottom: 'calc(-100vh - env(safe-area-inset-bottom, 0px))',
        }}
      >
        <Iridescence
          colors={[0.5, 0.8, 0.8]}
          speed={0.7}
        />
      </div>
      
      <PillNav
        logo={logo}
        logoAlt="Syltix Logo"
        brandName="Syltix"
        items={navItems}
        activeHref={location.pathname}
        initialLoadAnimation
        pillTextColor="rgba(255, 255, 255, 0.95)"
        hoveredPillTextColor="#060010"
      />
      <div className="relative pt-24 min-h-screen min-h-[100dvh] z-10">
        <Routes>
          <Route path="/" element={<HeroAndSections />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
